import React, { useRef } from 'react'
import { FormattedMessage } from 'react-intl'
import { ViewportList } from 'react-viewport-list'

import { useAudienceMemberListQuery } from '../blocs/useAudience'
import { useLiveDataQuery } from '../../global/blocs/useLiveData'

import { AudienceMemberListItem } from './AudienceMemberListItem'

import './AudienceList.scss'

const AudienceList = () => {
  const scrollContainerRef = useRef<HTMLDivElement>(null)
  const { data: audienceList, isLoading } = useAudienceMemberListQuery()

  const { data: liveData, isLoading: isLiveDataLoading } = useLiveDataQuery()

  if (isLoading || isLiveDataLoading) return null

  if (audienceList?.length === 0) {
    return (
      <div className="audience-list-empty-message">
        {liveData?.draft_p ? (
          <FormattedMessage defaultMessage="To be able to invite people to your webinar, you should leave draft mode." />
        ) : (
          <FormattedMessage defaultMessage="There is currently no audience in the webinar room." />
        )}
      </div>
    )
  }

  return (
    <div ref={scrollContainerRef} className="audience-list">
      <ViewportList
        viewportRef={scrollContainerRef}
        items={audienceList}
        axis="y"
        itemSize={48}
        overscan={2}
      >
        {(memberUuid) => (
          <AudienceMemberListItem key={memberUuid} uuid={memberUuid} />
        )}
      </ViewportList>
    </div>
  )
}

export { AudienceList }
